export default function getBaseUrl() {
  if (window.location?.hostname === "localhost") return { subDomain: "admin", baseUrl: "https://api.themedius.ai" };
  const host = window.location.host;
  const hostSplitArr = host.split(".");
  if (hostSplitArr[0] === "dev") return { subDomain: hostSplitArr[1], baseUrl: "https://dev.api.themedius.ai" };

  return { subDomain: hostSplitArr[0], baseUrl: "https://api.themedius.ai" };
}
